import React, { FC, useState, useEffect, useContext } from 'react'
import { notify } from 'react-notify-toast'
import { isMobile } from 'react-device-detect'
import history from '../../history'

import GenericBackgroundLayer from '../../GenericComponents/GenericBackgroundLayer'
import NavigationBar from '../NavigationBar/NavigationBar'
import GenericTextSpan from '../../GenericComponents/GenericTextSpan'
import GenericMainCard from '../../GenericComponents/GenericMainCard'
import GenericSwitch from '../../GenericComponents/GenericSwitch'
import GenericButton from '../../GenericComponents/GenericButton'
import GenericLogo from '../../GenericComponents/GenericLogo'
import GenericMobileTopNavigation from '../../GenericComponents/GenericMobileTopNavigation'
import GenericRow from '../../GenericComponents/GenericRow'
import Loader from '../Loader/Loader'

import { usePromiseTracker, trackPromise } from 'react-promise-tracker'

import ChangeTrainingDays from '../AddUserScreen/views/WizzardPage5'

import {
  editUserTrainingDays,
  getTrainingDays,
  getUserData,
  setUserTrainingDays,
} from '../../Api/backendApi'
import AppContext from '../../context/appContext'
import { arrayRemove } from '../../utils/ArrayHelpers'
import GenericInput from '../../GenericComponents/GenericInput'
import GenericColumn from '../../GenericComponents/GenericColumn'

interface PlanScreenInterface {
  setUserName: Function
}

const PlanScreen: FC<PlanScreenInterface> = ({}) => {
  const appContext = useContext(AppContext)
  const { promiseInProgress } = usePromiseTracker()
  const [user, setUser] = useState(Object)
  const [userTrainingDays, setUserTrainingDays] = useState(Array)
  const [trainingReminder, setTrainingReminder] = useState(false)
  const [trainingData, setTrainingData] = useState(Object)
  const [activeChange, setActiveChange] = useState(false)
  const [userTrainingTimeReminderHours, setUserTrainingTimeReminderHours] =
    useState((trainingData && trainingData.hour) || null)
  const [userTrainingTimeReminderMinutes, setUserTrainingTimeReminderMinutes] =
    useState((trainingData && trainingData.minute) || null)

  useEffect(() => {
    obtainUser()
    obtainTrainingData()
  }, [])

  useEffect(() => {
    if (userTrainingDays.length) {
      if (
        userTrainingDays != trainingData.trainingDays ||
        trainingReminder != trainingData.notification_enabled ||
        trainingData.hour !== userTrainingTimeReminderHours ||
        trainingData.minute !== userTrainingTimeReminderMinutes
      ) {
        setActiveChange(true)
      } else {
        setActiveChange(false)
      }
    }
  }, [
    userTrainingDays,
    trainingReminder,
    userTrainingTimeReminderHours,
    userTrainingTimeReminderMinutes,
  ])

  const formatHourTime = (trainingHour: any) => {
    let hour

    if (trainingHour < 10) {
      hour = `0${trainingHour}`
    } else {
      hour = trainingHour
    }
    return `${hour}`
  }

  const formatMinuteTime = (trainingMinute: any) => {
    let minute

    if (trainingMinute < 10) {
      minute = `0${trainingMinute}`
    } else {
      minute = trainingMinute
    }

    return `${minute}`
  }

  const goBackToMainpage = () => {
    history.push('/trening')
  }

  const obtainUser = async () => {
    if (appContext.appState.user) {
      setUser(appContext.appState.user)
    }

    const user = await getUserData()
    setUser(user)
    appContext.updateAppState('user', user)
  }

  const obtainTrainingData = async () => {
    if (appContext.appState.trainingData) {
      setTrainingData(appContext.appState.trainingData)
      setTrainingReminder(appContext.appState.trainingData.notification_enabled)
      setUserTrainingDays(appContext.appState.trainingData.trainingDays)
      setUserTrainingTimeReminderHours(appContext.appState.trainingData.hour)
      setUserTrainingTimeReminderMinutes(
        appContext.appState.trainingData.minute
      )
    }
    const trainingRespo: any = await getTrainingDays()

    setTrainingData(trainingRespo)
    setUserTrainingDays(trainingRespo.trainingDays)
    setTrainingReminder(trainingRespo.notification_enabled)
    setUserTrainingTimeReminderHours(trainingRespo.hour)
    setUserTrainingTimeReminderMinutes(trainingRespo.minute)
    appContext.updateAppState('trainingData', trainingRespo)
  }

  const handleChangeReminder = () => {
    setTrainingReminder(!trainingReminder)
  }

  const handleChangeTrainingDay = (e: any) => {
    if (userTrainingDays.length >= 5) {
      if (!userTrainingDays.includes(e.target.name)) {
      } else {
        let newDays = arrayRemove(userTrainingDays, e.target.name)
        setUserTrainingDays(newDays)
      }
    } else {
      if (!userTrainingDays.includes(parseInt(e.target.name))) {
        setUserTrainingDays([...userTrainingDays, parseInt(e.target.name)])
      } else {
        let newDays = arrayRemove(userTrainingDays, e.target.name)
        setUserTrainingDays(newDays)
      }
    }
  }

  const handleSetUserTrainingTimeReminder = (value: string | any) => {
    setUserTrainingTimeReminderHours(value.split(':')[0])
    setUserTrainingTimeReminderMinutes(value.split(':')[1])
  }

  const handleSaveChanges = async () => {
    if (userTrainingDays.length < 5) {
      notify.show(
        `Musisz zaznaczyć conajmniej 5 dni treningowych`,
        'error',
        3000
      )
      return
    } else {
      let updatedTrainingDays = await trackPromise(
        editUserTrainingDays(
          userTrainingDays,
          trainingData.trainingId,
          trainingReminder
            ? [userTrainingTimeReminderHours, userTrainingTimeReminderMinutes]
            : ['12', '00'],
          trainingReminder
        )
      )

      if (updatedTrainingDays) {
        appContext.updateAppState('trainingData', updatedTrainingDays)
        obtainTrainingData()
      }
    }
  }

  return (
    <GenericBackgroundLayer
      fDir={'column'}
      justify={'flex-start'}
      align={'center'}
      className={`${
        appContext.appState.theme == 'light' ? 'light' : 'standard'
      } plan-screen`}
    >
      <NavigationBar isPlayerView={false} backButtonAction={goBackToMainpage} />
      {isMobile && (
        <GenericMobileTopNavigation
          isPlayerView={false}
          dietCartClick={null}
          handleClick={() => goBackToMainpage()}
        />
      )}
      <GenericMainCard
        margin={isMobile ? '0 auto' : '5% auto 0 auto'}
        maxWidth={'1000px'}
        className="standard"
        width={isMobile ? '95%' : '60%'}
        flexDir="column"
      >
        <GenericTextSpan margin={'0% 0 0 0'} fSize={'1.8rem'}>
          Plan ćwiczeń
        </GenericTextSpan>
        <ChangeTrainingDays
          singleComponent={true}
          chosenTrainingDays={userTrainingDays}
          handleChangeTrainingDay={handleChangeTrainingDay}
        />
        <GenericSwitch
          text={'Przypominaj o treningu'}
          handleChange={handleChangeReminder}
          checked={trainingReminder}
          defaultChecked={false}
        />
        {trainingReminder && (
          <GenericColumn
            className="training-time-reminder"
            margin={'3% 0 0 0'}
            width={isMobile ? '50%' : '50%'}
          >
            <GenericRow
              className="time"
              justify={'space-evenly'}
              fSize={'2rem'}
            >
              <GenericTextSpan fSize={'1.3rem'}>O godzinie: </GenericTextSpan>
              <input
                onChange={(e: any) =>
                  handleSetUserTrainingTimeReminder(e.target.value)
                }
                type="time"
                defaultValue={`${
                  trainingData && trainingData.hour
                    ? formatHourTime(trainingData.hour)
                    : '12'
                }:${
                  trainingData && trainingData.minute
                    ? formatMinuteTime(trainingData.minute)
                    : '00'
                }`}
              ></input>
            </GenericRow>
          </GenericColumn>
        )}
        {activeChange && (
          <GenericButton
            width={isMobile ? '90%' : '40%'}
            tAlign={'center'}
            justify={'center'}
            className="standard"
            margin={'5% 0 0 0'}
            onClick={() => handleSaveChanges()}
          >
            Zatwierdź
          </GenericButton>
        )}
      </GenericMainCard>
      {!isMobile && window.innerWidth > 1500 && (
        <GenericLogo
          theme={appContext.appState.theme == 'light' ? 'light' : null}
          margin={'3% auto'}
        />
      )}
      {promiseInProgress && <Loader />}
    </GenericBackgroundLayer>
  )
}

export default PlanScreen
